import {z} from "zod";

const numberish = z.union([z.number(), z.string().min(1)]).pipe(z.coerce.number());
const stringish = z.union([z.string(), z.number()]).pipe(z.coerce.string());

const Horse = z.object({
    no: stringish,
    name: z.string().catch(""),
    run_status: z.boolean().catch(false),
    stablemate: stringish.catch(""),
    agf_ratio1: numberish.nullable().catch(null),
    agf_ratio2: numberish.nullable().catch(null),
    agf_sort_no1: numberish.nullable().catch(null),
    agf_sort_no2: numberish.nullable().catch(null),
}).passthrough();

const Odd = z.object({
    id: stringish.catch(""),
    horse_no: stringish.catch(""),
    win_odds: numberish.nullable().catch(null),
    place_odds: numberish.nullable().catch(null),
}).passthrough();

const Bet = z.object({
    code: stringish.catch(""),
}).passthrough();

const Run = z.object({
    no: numberish,
    time: z.string().catch(""),
    status: numberish.nullable().catch(null),
    horses: z.array(Horse).catch([]),
    // event_odds null gelebiliyor; boş nesneye indiriliyor ki tüketiciler koşulsuz Object.entries edebilsin.
    event_odds: z.record(z.string(), Odd).nullable().default(null).transform((v) => v ?? {}),
    bets: z.array(Bet).catch([]),
    show_fob: z.boolean().catch(false),
    fob_wager_status: z.boolean().catch(false),
}).passthrough();

const Wager = z.object({
    type: stringish,
    wager: z.string().catch(""),
    price: numberish.nullable().catch(null),
    runs: z.array(numberish).catch([]),
}).passthrough();

const HippodromeRaw = z.object({
    _id: z.string().min(1),
    card_id: stringish.catch(""),
    date: z.string().min(1),
    opening: z.string().min(1),
    hippodrome: z.string().min(1),
    keyword: z.string().min(1),
    runs: z.array(Run).min(1),
    wager_details: z.array(Wager).catch([]),
    show_fob: z.boolean().catch(false),
    status: z.boolean().catch(false),
}).passthrough();

type HippodromeRaw = z.infer<typeof HippodromeRaw>;

/**
 * Yanıttaki bir hipodromu doğrular. Doğrulama BAŞARISIZ olursa ham nesne olduğu gibi geri
 * dönüyor - eleme YAPILMIYOR. Sebep: şema gerçekliğin gerisinde kalırsa canlıda veri kaybı
 * olur; şu anki amaç önce sorunu görünür kılmak. Loglar temizlendikten sonra elemeye geçilebilir.
 */
export function validateHippodrome(raw: any): { data: any; ok: boolean } {
    const parsed = HippodromeRaw.safeParse(raw);
    if (parsed.success) {
        return {data: raw, ok: true};
    }
    console.warn(
        `%c[bulletin] şema uyuşmadı: ${raw?.hippodrome ?? raw?._id ?? "?"}`,
        "color: black; background: yellow; font-size: 11px; font-weight:bold",
        parsed.error.issues.slice(0, 5)
    );
    return {data: raw, ok: false};
}
